<app-logged-in-header *ngIf="user && !isFullPageView"></app-logged-in-header>

<div class="app-content" [ngClass]="{'fill-page': !user || isFullPageView}">
    @if(user && !isFullPageView)
    {
    <div class="dark-overlay" *ngIf="isSideNavOpen" (click)="closeSideBar()"></div>

    @if( [ 'ADMIN', 'SUPER_ADMIN', 'LGA_APPROVING_ADMIN', 'CHAIRMAN_LGA', 'LGA_ADMIN'].includes(user?.role)) {
    <app-admin-side-nav class="app-side-nav" [ngClass]="{ hidden: !isSideNavOpen,}"></app-admin-side-nav>
    }
    @else {
    <app-non-admin-side-nav class="app-side-nav" [ngClass]="{ hidden: !isSideNavOpen,}"></app-non-admin-side-nav>
    }
    }

    <div class="outlet">
        <router-outlet></router-outlet>
    </div>
</div>
